import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  CssBaseline,
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Avatar,
  Chip,
  Divider,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import EventNoteIcon from "@mui/icons-material/EventNote";
import DescriptionIcon from "@mui/icons-material/Description";
import SchoolIcon from "@mui/icons-material/School";
import PeopleIcon from "@mui/icons-material/People";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import PaymentIcon from "@mui/icons-material/Payment";
import InventoryIcon from "@mui/icons-material/Inventory";
import BusinessIcon from "@mui/icons-material/Business";
import InsightsIcon from "@mui/icons-material/Insights";
import BadgeIcon from "@mui/icons-material/Badge";
import { Outlet } from "react-router-dom";
import useDataUsr from "../../hooks/useDataUsr";
import BrandLogo from "./BrandLogo";
import Cookies from "js-cookie";

const auth_service = require("../../helpers/authService");

const DRAWER_WIDTH = 248;

export default function Layout() {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up("md"));
  const [open, setOpen] = useState(false);
  const { dataUsr } = useDataUsr();
  const [menu, setMenu] = useState([]);

  // Mismo reparto de menu por rol que traia el AppBar anterior; lo unico que se
  // agrego es el icono de cada entrada para el sidebar.
  useEffect(() => {
    if (dataUsr) {
      if (dataUsr.permisos === "ADMINISTRADOR") {
        setMenu([
          {
            label: "Agendas Mensuales",
            href: process.env.REACT_APP_REDIRECT_ADMINISTRATIVO,
            icon: <EventNoteIcon fontSize="small" />,
          },
          {
            label: "Formularios",
            href: process.env.REACT_APP_REDIRECT_FORMS,
            icon: <DescriptionIcon fontSize="small" />,
          },
          {
            label: "Docentes",
            href: "/docente",
            icon: <SchoolIcon fontSize="small" />,
          },
          {
            label: "Usuarios",
            href: "/users",
            icon: <PeopleIcon fontSize="small" />,
          },
          {
            label: "Asesores",
            href: "/asesor",
            icon: <SupportAgentIcon fontSize="small" />,
          },
          {
            label: "Help Desk",
            href: "/ticket-soporte",
            icon: <HeadsetMicIcon fontSize="small" />,
          },
          {
            label: "Secretos",
            href: "/secrets",
            icon: <VpnKeyIcon fontSize="small" />,
          },
          {
            label: "Integraciones Pasarela de Pago",
            href: "/pasarela-pago-integraciones",
            icon: <PaymentIcon fontSize="small" />,
          },
          {
            label: "Inventario IT",
            href: "/inventario-ti",
            icon: <InventoryIcon fontSize="small" />,
          },
          {
            label: "In House",
            href: "/in-house",
            icon: <BusinessIcon fontSize="small" />,
          },
          { label: "UC", href: "/uc", icon: <InsightsIcon fontSize="small" /> },
        ]);
      } else if (
        dataUsr.permisos === "CONTROL-ACADEMICO" ||
        dataUsr.permisos === "DIRECCION-COMERCIAL" ||
        dataUsr.permisos === "SUBGERENCIA"
      ) {
        setMenu([
          {
            label: "Agendas Mensuales",
            href: process.env.REACT_APP_REDIRECT_ADMINISTRATIVO,
            icon: <EventNoteIcon fontSize="small" />,
          },
          {
            label: "Formularios",
            href: process.env.REACT_APP_REDIRECT_FORMS,
            icon: <DescriptionIcon fontSize="small" />,
          },
          {
            label: "Help Desk",
            href: "/ticket-soporte",
            icon: <HeadsetMicIcon fontSize="small" />,
          },
          {
            label: "In House",
            href: "/in-house",
            icon: <BusinessIcon fontSize="small" />,
          },
        ]);
      } else if (
        dataUsr.permisos === "COMERCIAL" ||
        dataUsr.permisos === "REDES SOCIALES"
      ) {
        setMenu([
          {
            label: "Perfil Asesor Comercial",
            href: "/asesor-profile",
            icon: <BadgeIcon fontSize="small" />,
          },
          {
            label: "Agendas Mensuales",
            href: process.env.REACT_APP_REDIRECT_ADMINISTRATIVO,
            icon: <EventNoteIcon fontSize="small" />,
          },
          {
            label: "Help Desk",
            href: "/ticket-soporte",
            icon: <HeadsetMicIcon fontSize="small" />,
          },
          {
            label: "In House",
            href: "/in-house",
            icon: <BusinessIcon fontSize="small" />,
          },
        ]);
      } else if (dataUsr.permisos === "DIRECCION-ACADEMICA") {
        setMenu([
          {
            label: "Agendas Mensuales",
            href: process.env.REACT_APP_REDIRECT_ADMINISTRATIVO,
            icon: <EventNoteIcon fontSize="small" />,
          },
          {
            label: "Help Desk",
            href: "/ticket-soporte",
            icon: <HeadsetMicIcon fontSize="small" />,
          },
          {
            label: "In House",
            href: "/in-house",
            icon: <BusinessIcon fontSize="small" />,
          },
        ]);
      } else {
        setMenu([
          {
            label: "Agendas Mensuales",
            href: process.env.REACT_APP_REDIRECT_ADMINISTRATIVO,
            icon: <EventNoteIcon fontSize="small" />,
          },
          {
            label: "Help Desk",
            href: "/ticket-soporte",
            icon: <HeadsetMicIcon fontSize="small" />,
          },
        ]);
      }
    }
  }, [dataUsr]);

  const handleLogout = () => {
    const cookieOptions = { domain: process.env.REACT_APP_DOMAIN };
    const removeCookieAndRedirect = () => {
      Cookies.remove(process.env.REACT_APP_COOKIE_KEY, cookieOptions);
      window.location.href = process.env.REACT_APP_REDIRECT_ENDPOINT;
    };
    let jwt;
    try {
      const raw = Cookies.get(process.env.REACT_APP_COOKIE_KEY);
      jwt = raw ? JSON.parse(raw) : null;
    } catch (e) {
      jwt = null;
    }
    if (!jwt || !jwt.TokenType || !jwt.refreshToken) {
      removeCookieAndRedirect();
      return;
    }
    auth_service
      .getDataAuth("/usr/logout", jwt.TokenType, jwt.refreshToken)
      .then(removeCookieAndRedirect)
      .catch((err) => {
        console.log(err);
        removeCookieAndRedirect();
      });
  };

  const drawerContent = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        bgcolor: "#0e1a26",
      }}
    >
      <Box
        sx={{
          p: "20px",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <BrandLogo subtitle="Control Académico" />
      </Box>

      <List sx={{ flex: 1, overflowY: "auto", px: 1.5 }}>
        {menu.map((page) => (
          <ListItemButton
            key={page.label}
            sx={{ borderRadius: 2, mb: 0.25 }}
            selected={window.location.pathname === page.href}
            onClick={() => {
              setOpen(false);
              window.location.href = page.href;
            }}
          >
            <ListItemIcon sx={{ minWidth: 34, color: "inherit" }}>
              {page.icon}
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{ fontSize: 13.5, fontWeight: 500 }}
              primary={page.label}
            />
          </ListItemButton>
        ))}
      </List>

      <Divider />
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, p: 2 }}>
        <Avatar src={dataUsr?.picture} sx={{ width: 34, height: 34 }} />
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography noWrap sx={{ fontSize: 13, fontWeight: 600 }}>
            {dataUsr?.Username}
          </Typography>
          <Typography sx={{ fontSize: 11, color: "text.secondary" }}>
            {dataUsr?.permisos}
          </Typography>
        </Box>
        <Tooltip title="Mi perfil">
          <IconButton
            size="small"
            onClick={() => {
              window.location.href = "/profile";
            }}
          >
            <AccountBoxIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Cerrar sesión">
          <IconButton size="small" onClick={handleLogout}>
            <LogoutIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );

  return (
    <React.Fragment>
      <CssBaseline />
      <Box sx={{ display: "flex", minHeight: "100vh" }}>
        {desktop ? (
          <Drawer
            variant="permanent"
            sx={{
              width: DRAWER_WIDTH,
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: DRAWER_WIDTH,
                borderRight: "1px solid #1c2f42",
              },
            }}
          >
            {drawerContent}
          </Drawer>
        ) : (
          <Drawer
            variant="temporary"
            open={open}
            onClose={() => setOpen(false)}
            ModalProps={{ keepMounted: true }}
            sx={{ "& .MuiDrawer-paper": { width: 264 } }}
          >
            {drawerContent}
          </Drawer>
        )}

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <AppBar
            position="sticky"
            elevation={0}
            sx={{ bgcolor: "#0e1a26", borderBottom: "1px solid #1c2f42" }}
          >
            <Toolbar sx={{ gap: 1.5 }}>
              {!desktop && (
                <IconButton
                  color="inherit"
                  edge="start"
                  onClick={() => setOpen(true)}
                >
                  <MenuIcon />
                </IconButton>
              )}
              <Typography sx={{ fontSize: 15, fontWeight: 600, flex: 1 }}>
                Portal EBG
              </Typography>
              {dataUsr?.permisos && (
                <Chip
                  label={dataUsr.permisos}
                  size="small"
                  sx={{
                    color: "#d9a441",
                    bgcolor: "rgba(217,164,65,0.1)",
                    border: "1px solid rgba(217,164,65,0.35)",
                  }}
                />
              )}
              <Avatar src={dataUsr?.picture} sx={{ width: 32, height: 32 }} />
            </Toolbar>
          </AppBar>

          <Box
            component="main"
            id="back-to-top-anchor"
            sx={{ p: { xs: 2, md: 3 }, maxWidth: 1400, mx: "auto" }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}
